import {
    DeliveryTypeDto,
    PaymentTypeDto,
    StaffCallKindDto,
    StorefrontPhotosModeDto,
    ThemeIdDto,
} from "services/menu/restModels";

import { MenuSettingsTab, WeekDayKey } from "features/MenuSettings/types";

export const MENU_SETTINGS_TABS: { key: MenuSettingsTab; label: string }[] = [
    { key: "general", label: "О заведении" },
    { key: "appearance", label: "Оформление" },
    { key: "settings", label: "Настройки" },
    { key: "orderMethods", label: "Способы заказа" },
    { key: "payments", label: "Способы оплаты" },
    { key: "chats", label: "Уведомления" },
];

export const DEFAULT_MENU_SETTINGS_TAB: MenuSettingsTab = "general";

export const WEEK_DAYS: { key: WeekDayKey; label: string }[] = [
    { key: "monday", label: "Понедельник" },
    { key: "tuesday", label: "Вторник" },
    { key: "wednesday", label: "Среда" },
    { key: "thursday", label: "Четверг" },
    { key: "friday", label: "Пятница" },
    { key: "saturday", label: "Суббота" },
    { key: "sunday", label: "Воскресенье" },
];

// Часовые пояса с получасовым шагом, как в старой форме: от UTC-12 до UTC+12.
export const TIMEZONE_OPTIONS: { value: number; label: string }[] = Array.from(
    { length: 49 },
    (_item, index) => {
        const minutes = -720 + index * 30;
        const hours = minutes / 60;
        const sign = minutes < 0 ? "−" : "+";
        const absHours = Math.abs(hours);
        const label = Number.isInteger(absHours)
            ? `UTC${sign}${absHours}`
            : `UTC${sign}${Math.floor(absHours)}:30`;
        return { value: minutes, label };
    }
);

export const LOCALE_LABELS: Record<string, string> = {
    ru: "Русский",
    en: "Английский",
    zh: "Китайский",
    it: "Итальянский",
};

// Русский всегда включён — гостевое меню без базового языка останется без текстов.
export const PRIMARY_LOCALE = "ru";

export const SELECTABLE_LOCALES = ["ru", "en", "zh", "it"];

export const THEME_OPTIONS: { value: ThemeIdDto; label: string }[] = [
    { value: "default", label: "Красные кнопки" },
    { value: "expensiveBlack", label: "Чёрные кнопки" },
];

export const ITEM_PHOTOS_MODE_OPTIONS: {
    value: StorefrontPhotosModeDto;
    label: string;
}[] = [
    { value: "defaultWithPhotos", label: "С фотографиями" },
    { value: "defaultNoPhotos", label: "Без фотографий" },
];

export interface DeliveryTypeMeta {
    type: DeliveryTypeDto;
    title: string;
    description: string;
}

export const DELIVERY_TYPES: DeliveryTypeMeta[] = [
    {
        type: "InsideTheRestaurant",
        title: "Внутри заведения без выбора стола",
        description:
            "Подходит для приема заказов у барной стойки без участия человека.",
    },
    {
        type: "ToRestaurantTable",
        title: "Внутри заведения с выбором стола",
        description:
            "Подходит для заказа за столик без участия официанта. Гость сможет выбрать столик для заказа",
    },
    {
        type: "TakeAway",
        title: "На вынос",
        description: "Подходит для заказа на вынос. Гость укажет телефон.",
    },
    {
        type: "TakeAwayToTime",
        title: "Самовывозом в указанное время",
        description:
            "Подходит для заказа самовывозом ко времени. Гость укажет телефон и время для сбора заказа.",
    },
    {
        type: "ToAddress",
        title: "Доставка",
        description:
            "Подходит для заказа на доставку до дома. Гость укажет адрес доставки и телефон",
    },
    {
        type: "ToVehicle",
        title: "Доставка до машины",
        description:
            "Подходит для заказа на доставку до машины. Гость укажет телефон, номер и марку машины",
    },
];

export interface StaffCallTypeMeta {
    kind: StaffCallKindDto;
    title: string;
    description: string;
}

// Порядок каталога — порядок кнопок у гостя.
export const STAFF_CALL_TYPES: StaffCallTypeMeta[] = [
    {
        kind: "Waiter",
        title: "Позвать официанта",
        description: "Гость позовёт официанта к своему столу.",
    },
    {
        kind: "Bill",
        title: "Попросить счёт",
        description: "Гость попросит счёт, не дожидаясь официанта.",
    },
    {
        kind: "Hookah",
        title: "Позвать кальянного мастера",
        description: "Подходит заведениям с кальянной картой.",
    },
    {
        kind: "Administrator",
        title: "Позвать администратора",
        description: "Гость позовёт администратора зала.",
    },
];

export interface PaymentTypeMeta {
    type: PaymentTypeDto;
    title: string;
    description: string;
}

export const PAYMENT_TYPES: PaymentTypeMeta[] = [
    {
        type: "Offline",
        title: "Оплата наличными/картой",
        description:
            "Оплата происходит отдельно от заказа. Например, вашему официанту или курьеру.",
    },
    {
        type: "CloudPaymentsCheckout",
        title: "Оплата через меню картой, Apple Pay и Google Pay",
        description:
            "Оплата происходит сразу же во время заказа через интернет. Фискальные чеки выдаются автоматически",
    },
    {
        type: "SBPTochka",
        title: "Оплата через меню СБП (Систему быстрых платежей)",
        description:
            "Оплата происходит сразу же во время заказа через интернет. Фискальные чеки выдаются автоматически",
    },
];
